import { Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { setMessage } from 'src/store/Message';
import { IQueryMenusProps } from 'src/types/Queries';
import { useFieldTranslation } from '../fields/useFieldTranslation';
import { ViewFieldAuditTrail } from './ViewFieldAuditTrail';
import { ViewQuery } from './ViewQuery/ViewQuery';
import { RaiseQuery } from './raiseQuery/RaiseQuery';

export const QueryMenus: React.FC<IQueryMenusProps> = ({
  contextMenu,
  setContextMenu,
  queryKeys,
  totalFieldQueries,
  totalSectionQueries,
  fieldQueries,
  getSivReportQueries,
  report_id,
  checkListQueries,
  queryType,
  setQueryType,
  isSQSivQueries
}) => {
  const [openViewQuery, setOpenViewQuery] = useState(false);
  const [openRaiseQuery, setOpenRaiseQuery] = useState(false);
  const [openFieldAuditTrail, setOpenFieldAuditTrail] = useState(false);
  const { checkPermission } = usePermissionWrapper();
  const { sectionQuery, fieldQuery, viewAllQueries, viewFieldQuery, raiseFieldQuery, raiseSectionQuery } =
    useFieldTranslation();
  const dispatch = useDispatch();

  return (
    <div>
      <div>
        <Menu
          open={contextMenu !== null}
          onClose={() => setContextMenu(null)}
          anchorReference="anchorPosition"
          anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
          className="querymenu"
        >
          {checkPermission(
            queryKeys?.report_category === 'SQREPT' || queryKeys?.report_category === 'SUSIVRT'
              ? queryKeys?.report_category === 'SQREPT'
                ? 'view_queries_sq_report'
                : queryKeys?.report_category === 'SUSIVRT'
                ? 'view_queries_siv_report'
                : ''
              : ''
          ) ? (
            <>
              <MenuItem
                  onClick={() => {
                    setOpenViewQuery(true);
                    setQueryType(fieldQuery);
                    setContextMenu(null);
                  }}
                >
                  {viewFieldQuery}
              </MenuItem>
              <MenuItem
                  onClick={() => {
                    setQueryType('ALL');
                    setOpenViewQuery(true);
                    setContextMenu(null);
                  }}
                >
                  {viewAllQueries}
              </MenuItem>
            </>
          ) : (
            <></>
          )}
          {checkPermission(
            queryKeys?.report_category === 'SQREPT' || queryKeys?.report_category === 'SUSIVRT'
              ? queryKeys?.report_category === 'SQREPT'
                ? 'raise_query_sq_report'
                : queryKeys?.report_category === 'SUSIVRT'
                ? 'raise_query_siv_report'
                : ''
              : ''
          ) ? (
            <MenuItem
                onClick={() => {
                  if (report_id != '' && report_id != undefined) {
                    setQueryType(fieldQuery);
                    setOpenRaiseQuery(true);
                    setContextMenu(null);
                  } else {
                    dispatch(
                      setMessage({
                        msgDetails: 'Cannot raise query without saving data',
                        severity: 'info'
                      })
                    );
                  }
                }}
              >
                {raiseFieldQuery}
            </MenuItem>
          ) : (
            <></>
          )}
          {checkPermission(
            queryKeys?.report_category === 'SQREPT' || queryKeys?.report_category === 'SUSIVRT'
              ? queryKeys?.report_category === 'SQREPT'
                ? 'view_audit_sq_report'
                : queryKeys?.report_category === 'SUSIVRT'
                ? 'view_audit_siv_report'
                : ''
              : ''
          ) ? (
            <>
              <MenuItem
                  onClick={() => {
                    setQueryType('Field');
                    setOpenFieldAuditTrail(true);
                    setContextMenu(null);
                  }}>
                  View Field Audit Trail
              </MenuItem>
              <MenuItem
                  onClick={() => {
                    setQueryType('ALL');
                    setOpenFieldAuditTrail(true);
                    setContextMenu(null);
                  }}
                >
                  View All Audit Trail
              </MenuItem>
            </>
          ) : (
            <></>
          )}
          {checkPermission(
            queryKeys?.report_category === 'SQREPT' || queryKeys?.report_category === 'SUSIVRT'
              ? queryKeys?.report_category === 'SQREPT'
                ? 'raise_query_sq_report'
                : queryKeys?.report_category === 'SUSIVRT'
                ? 'raise_query_siv_report'
                : ''
              : ''
          ) ? (
            <MenuItem
                onClick={() => {
                  if (report_id != '' && report_id != undefined) {
                    setQueryType(sectionQuery);
                    setOpenRaiseQuery(true);
                    setContextMenu(null);
                  } else {
                    dispatch(
                      setMessage({
                        msgDetails: 'Cannot raise query without saving data',
                        severity: 'info'
                      })
                    );
                  }
                }}
              >
                {raiseSectionQuery}
            </MenuItem>
          ) : (
            <></>
          )}
        </Menu>
      </div>
      <div>
        <ViewQuery
          totalFieldQueries={totalFieldQueries}
          totalSectionQueries={totalSectionQueries}
          open={openViewQuery}
          setOpen={setOpenViewQuery}
          queryKeys={queryKeys}
          queryType={queryType}
          fieldQueries={fieldQueries}
          getSivReportQueries={getSivReportQueries}
          setQueryType={setQueryType}
          report_id={report_id}
          isSQSivQueries={isSQSivQueries}
        />
        <RaiseQuery
          openRaiseQuery={openRaiseQuery}
          setOpenRaiseQuery={setOpenRaiseQuery}
          queryKeys={queryKeys}
          queryType={queryType}
          getSivReportQueries={getSivReportQueries}
          setContextMenu={setContextMenu}
          report_id={report_id}
        />
        <ViewFieldAuditTrail
          openFieldAuditTrail={openFieldAuditTrail}
          setOpenFieldAuditTrail={setOpenFieldAuditTrail}
          queryKeys={queryKeys}
          queryType={queryType}
          checkListQueries={checkListQueries}
        />
      </div>
    </div>
  );
};
